import React from 'react'
import Button from '../../utils/Button'
import GeneralLoader from '../../GeneralLoader';
import isEmpty from 'lodash/isEmpty';

const AdminManagersList = ({ loading, managers, handleDeleteManager }) => {
    return (
        <div className="fieldset">
            <div className="title-label">All Specialists</div>

            <div className='fieldset-indent pt1'>
                {loading
                    ? <GeneralLoader/> 
                    : <table className="display_table" style={{width: 'fit-content'}}>
                        <thead>
                            <tr className="table-header">
                                <th>#</th>
                                <th>Specialist Email</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!isEmpty(managers) 
                                ? managers.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index}</td>
                                        <td data-id="Email">{item.username}</td>
                                        <td>
                                            <Button
                                                classes="delete-btn"
                                                clickHandler={() => handleDeleteManager(item.id)}
                                                text={'Delete'}
                                            />
                                        </td>
                                    </tr>
                                ))
                                : <tr>
                                    <td colSpan={3}>There are currently no specialist accounts.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    )
}

export default AdminManagersList


// WEBPACK FOOTER //
// ./src/components/admin/managers/AdminManagersList.js